import { useApiGetQuery, useApiMutation } from 'utils/queryClient'

export const currentUserQueryKey = ['currentUser']

const useCurrentUser = (options = {}) =>
  useApiGetQuery({
    endpoint: '/users/me',
    queryKey: currentUserQueryKey,
    options,
  })

export const useUpdateCurrentUser = (options = {}) =>
  useApiMutation('/users/me', 'patch', options)

export default useCurrentUser
